<template>
  <!-- 1发动态 2评论 3回复弹框 -->
  <!-- 只有文本域的弹框 -->
  <el-dialog class="dialog-create-dynamic" :title="titleStr" :visible.sync="dialogVisible" width="930px">
    <div class="content">
      <el-form class="g-form-grid" ref="form" :model="form" :rules="rules">
        <el-form-item prop="content">
          <el-input type="textarea" v-model="form.content" placeholder="请输入" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <cmpUploadMainPhonto v-if="pageType === '1'" :callFun="getPhotoList" :businessType="`dynamic`"  :showMainBtn="false" :fileList="pictureList"></cmpUploadMainPhonto>

      <div slot="footer" class="footer tr">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">发布</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cmpUploadMainPhonto from '@cmp/my-upload/main-photo'
export default {
  components: { cmpUploadMainPhonto },
  data() {
    return {
      dialogVisible: false,
      loadingSave: false,
      form: {
        content: ''
      },
      pictureIds: '',
      pictureList: [],
      rules: {
        content: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      titleStr: '',
      pageType: '1', // 1发动态 2评论 3回复
      dynamicId: '', // 动态id
      answerCommentId: '' //评论id
    }
  },
  methods: {
    init(pageType, dynamicId, answerCommentId) {
      this.pageType = pageType || '1' // 1发动态 2评论 3回复
      this.dynamicId = dynamicId || ''
      this.answerCommentId = answerCommentId || '' // 动态id
      this.loadingSave = false //评论id
      this.form = {
        content: ''
      }
      this.pictureList = []
      this.pictureIds = ''
      this.setTitle()

      this.dialogVisible = true

      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    setTitle() {
      switch (this.pageType) {
        case '1':
          this.titleStr = '发动态'
          break
        case '2':
          this.titleStr = '评论'
          break
        case '3':
          this.titleStr = '回复'
          break
      }
    },
    getPhotoList(ids) {
      console.log('id', ids)
      this.pictureIds = ids
    },
    fromSubmit(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true

          if (this.pageType === '1') {
            this.saveDynamic()
          } else {
            this.saveComment()
          }
        }
      })
    },
    saveDynamic() {
      this.$http
        .post('/wkDynamic/save', {
          dynamicContent: this.form.content,
          pictureIds: this.pictureIds
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('发布动态成功')
            this.dialogVisible = false
            this.$emit('refresh', this.pageType)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    },
    saveComment() {
      this.$http
        .post('/wkDynamic/comment', {
          commentContent: this.form.content,
          dynamicId: this.dynamicId,
          answerCommentId: this.answerCommentId //回复的评论ID
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success(
              this.pageType === '2' ? '评论成功' : '回复成功'
            )
            this.dialogVisible = false
            this.$emit('refresh', this.pageType, this.dynamicId)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-create-dynamic {
}
</style>
